<template>
  <section class="status-page">
    <div class="status-card animate-modal-enter">
      <div class="status-icon success">
        <svg class="w-16 h-16 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h1 class="text-2xl md:text-3xl font-extrabold mt-6" style="color:#195493">Inscrição Confirmada!</h1>
      <p class="text-gray-600 mt-3 text-lg">Seu número de inscrição e QR Code foram enviados para o seu e-mail e WhatsApp.</p>
      <p class="text-sm text-gray-400 mt-2">Verifique também a caixa de spam.</p>

      <div class="info-box">
        <p><strong>Retirada do kit:</strong> 25 a 28 de abril, 8h às 17h</p>
        <p><strong>Concentração:</strong> 7h - Hotel Escola, Xerém</p>
        <p><strong>Data do evento:</strong> 1º de Maio de 2026</p>
      </div>

      <router-link to="/" class="btn-back">Voltar ao Início</router-link>
    </div>
  </section>
</template>

<script>
export default { name: "PageSucess" };
</script>

<style scoped>
.status-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #195493 0%, #0f3460 100%);
  padding: 2rem;
}
.status-card {
  background: white;
  border-radius: 1.5rem;
  padding: 3rem;
  text-align: center;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 25px 60px rgba(0,0,0,0.3);
}
.status-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
.status-icon.success { background: #2ecc71; }
.info-box {
  background: #f8f8f8;
  border-radius: 0.75rem;
  padding: 1rem 1.5rem;
  margin: 1.5rem 0;
  text-align: left;
}
.info-box p {
  color: #195493;
  font-size: 0.9rem;
  margin: 0.3rem 0;
}
.btn-back {
  display: inline-block;
  background: #E8652D;
  color: white;
  font-weight: 700;
  padding: 0.8rem 2rem;
  border-radius: 50px;
  text-decoration: none;
  transition: background 0.3s;
  text-transform: uppercase;
  font-size: 0.9rem;
  letter-spacing: 1px;
}
.btn-back:hover { background: #c9521f; }
</style>
